import { TrendingDown, TrendingUp } from "lucide-react";
import type { ReactNode } from "react";

/** Um KPI: ícone, rótulo, número grande e uma linha de contexto. Ver o
 *  cabeçalho de `Panel.tsx` pela origem. */
export function MetricCard({ icon, label, value, context, tone = "plain", change, watermark, title }: {
  icon: ReactNode; label: string; value: string; context: string; tone?: string; change?: number | null; watermark?: ReactNode;
  /** Tooltip nativo do card inteiro. Nasceu com a valoração, que
   *  precisa dizer o valor extenso E a regra de contagem por marca —
   *  os dois em `context` estourariam a linha do card. */
  title?: string;
}) {
  return (
    <article className={`dashboard-kpi dashboard-kpi--${tone}`} title={title}>
      {watermark}
      <div className="dashboard-kpi-head">
        <span className="dashboard-kpi-icon" aria-hidden="true">{icon}</span>
        {change !== undefined && change !== null && (
          <span
            className={`dashboard-kpi-change ${change >= 0 ? "is-up" : "is-down"}`}
            aria-label={`${change >= 0 ? "Aumento" : "Queda"} de ${Math.abs(change).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}% em relação ao período anterior`}
          >
            {change >= 0 ? <TrendingUp size={13} aria-hidden="true"/> : <TrendingDown size={13} aria-hidden="true"/>}
            <span aria-hidden="true">{Math.abs(change).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%</span>
          </span>
        )}
      </div>
      <span className="dashboard-kpi-label">{label}</span>
      <strong className="dashboard-kpi-value">{value}</strong>
      <span className="dashboard-kpi-context">{context}</span>
    </article>
  );
}
